import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ✅ Skip adding auth token for public auth endpoints
    const isAuthEndpoint = req.url.includes('/api/auth/') || req.url.includes('/api/user/login');

    // Get token from localStorage using standard key
    const authToken = localStorage.getItem('access_token');

    // ✅ If token exists and is valid AND it's not a public auth endpoint, add it to the request headers
    if (authToken && authToken !== 'null' && authToken !== '' && !isAuthEndpoint) {
      // Clone the request and add Authorization header
      console.log('🔐 SECURED request:', req.method, req.url);
      req = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });
    } else {
      // Ensure Content-Type is set even without token
      req = req.clone({
        setHeaders: {
          'Content-Type': 'application/json'
        }
      });
    }

    // Handle the request and catch errors
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('❌ HTTP Error:', {
          status: error.status,
          message: error.message,
          url: error.url
        });

        // ✅ If 401 Unauthorized on a protected endpoint, clear token and redirect to login
        if (error.status === 401 && !isAuthEndpoint) {
          console.warn('⚠️ Unauthorized (401) - clearing token and redirecting to login');
          localStorage.removeItem('access_token');
          localStorage.removeItem('roles');
          this.router.navigate(['/login']);
        }

        return throwError(() => error);
      })
    );
  }
}
